var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.821 12.35c2.063 2.049 4.45 4.005 5.388 3.06 1.343-1.352 2.169-2.528 5.147-.153 2.979 2.377.704 3.976-.596 5.286-1.5 1.512-7.12.106-12.689-5.421C.502 9.594-.946 3.986.555 2.474c1.3-1.31 2.883-3.597 5.28-.636 2.398 2.96 1.228 3.795-.114 5.148-.937.944 1.037 3.317 3.1 5.365Z",
    fill: "#949191"
  })));
};

export default SvgIconPhone;